<template>
    <ToggleGrid/>
    <UserName />
    <HamburgerToggle />
    <div class="profile-hero">
        <UserThemeCoverImage v-if="templateSettings.showProfilePicture" />
    </div>
    <div class="profile-bio">
        <UserPortfolioDescription />
    </div>
    <GetHeroNavigation :show-home-button="true" />
</template>

<script>
import UserName from "../../common/user/UserName.vue";
import UserThemeCoverImage from "../../common/user/UserThemeCoverImage.vue";
import UserPortfolioDescription from "../../common/user/UserPortfolioDescription.vue";
import HamburgerToggle from "../../../components/HamburgerToggle.vue";
import ToggleGrid from "../../../../common/components/ToggleGrid.vue";
import GetHeroNavigation from "../../common/hero/GetHeroNavigation.vue";
import {mapGetters} from "vuex";

export default {
    name: "ProfileThemeNine",
    components: {
        GetHeroNavigation,
        ToggleGrid,
        HamburgerToggle,
        UserPortfolioDescription,
        UserThemeCoverImage,
        UserName
    },
    computed: {
        ...mapGetters("view", ["viewData"]),
        portfolio() {
            return this.viewData.portfolio
        },
        templateSettings() {
            return this.viewData.portfolio.templateSettings
        }
    }
}
</script>